<template>
    <div>
        <CRow class="m-0 justify-content-center align-items-center">
            <div class="text-center">
                <!-- Full-width image -->
                <img class="w-100" src="../assets/img/mask.png" alt="Mask Image" />
    
                <div class="bg-white-radius p-2" style="position: relative; z-index: 1;">
                    <h5 class="custom-title-app poppin-font mt-2">Select Country</h5>
                    <p class="custom-sub-title-app poppin-font">Choose your country</p>
    
                    <div class="p-40">
                        <CSelect></CSelect>
                    </div>
    
                    <div class="p-40 mt-2">
                        <CButton @click="GoToWho" type="button" class="button-border-blue text-white" block>
                            Continue
                        </CButton>
                        <br /> <br /> <br />
                    </div>
                </div>
            </div>
        </CRow>
    </div>
</template>
  



<script>
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default {
  namespaced: true,
  data() {
    },
    methods: {
        GoToWho() {
            this.$router.push("/WhoAreYou");
        },
    }
  }
</script>
  